"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _has = _interopRequireDefault(require("lodash/has"));
var _isNaN = _interopRequireDefault(require("lodash/isNaN"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _BrixelButtonPrimary = _interopRequireDefault(require("../BrixelButtonPrimary"));
var _ReduxForm = require("../../utils/ReduxForm.Functions");
var _ReduxField = _interopRequireDefault(require("./ReduxField"));
var _helper = require("../../utils/helper");
var _FormActions = require("../../actions/FormActions");
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MultiFileldsRedux = props => {
  // PROPS
  const {
    disableEmailRegister = false,
    autocompleteData = null,
    autofocus = true,
    baseByData,
    baseURL = null,
    className = '',
    disableDelay = false,
    enableMultiple = true,
    errorValue = {},
    form,
    formValue,
    generatePassword = () => '',
    hintMessage = '',
    inputs = [],
    nestedInputs = [],
    onClick = null,
    onClickDisabled = false,
    onCloseGoBack = () => '',
    onRemoveFile = null,
    onSubmit = () => '',
    onSaveData,
    showButtonGenerate = false,
    showCheckMark = false,
    showErrors = false,
    showPassword = false,
    showSendButton = false,
    smallMargin = false
  } = props;
  // STATE
  const [curCountry] = (0, _react.useState)();
  const valideConditionInput = quest => {
    let isVerified = true;
    const {
      conditionsOr
    } = quest;
    if (quest.condition) {
      const conditions = (0, _isArray.default)(quest.condition) ? quest.condition : [quest.condition];
      conditions.map(item => {
        if ((0, _has.default)(item, 'value')) {
          // eslint-disable-next-line no-empty
          if (item.value === 'isPositive' && (0, _get.default)(formValue, item.name, 0) > 0) {} else if ((0, _get.default)(formValue, item.name, null) !== item.value) {
            isVerified = false;
          }
        }
        if (item.noValue && (0, _get.default)(formValue, item.name, null) === item.noValue) {
          isVerified = false;
        }
        return null;
      });
    }
    if (conditionsOr) {
      isVerified = false;
      conditionsOr.map(item => {
        if ((0, _has.default)(item, 'value')) {
          if (item.value === 'isPositive' && (0, _get.default)(formValue, item.name, 0) > 0 || (0, _get.default)(formValue, item.name, 'a') === item.value) {
            isVerified = true;
          }
        }
        if (item.noValue && (0, _get.default)(formValue, item.name, null) !== item.noValue) {
          isVerified = true;
        }
        return null;
      });
    }
    return isVerified;
  };
  const marginTopBox = (i, classBoxWrapper) => {
    if (classBoxWrapper) return classBoxWrapper;
    if (i > 0) {
      if (smallMargin) return 'mt-2';
      return 'mt-5';
    }
    return '';
  };
  // TODO review after change helpers to ts
  // @ts-ignore
  const hideOnDesk = (0, _helper.getBrowserPlatform)().indexOf('desk') !== -1 ? 'hide-desktop' : 'dis-b-mobile';
  if (!formValue) {
    return /*#__PURE__*/_react.default.createElement("div", null);
  }
  const inputComponent = (input, f) => (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: f.toString()
  }, valideConditionInput(input) && (/*#__PURE__*/_react.default.createElement("div", {
    className: `${className} multiFieldWrap ${(0, _get.default)(input, 'classWidthBox', null) ? input.classWidthBox : `w-perc-${(0, _get.default)(input, 'widthBox', '100')}`} ${marginTopBox(f, input.classBoxWrapper)}`
  }, input.title && (/*#__PURE__*/_react.default.createElement("h6", {
    className: "mt-5 mb-3"
  }, input.title)), /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-f jc-b h-perc-100 ${input.label ? 'a-t' : 'a-c'}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${input.classNameBox || ''} ${showCheckMark ? 'withCheckMark dis-f' : 'dis-f-col'} jc-b w-perc-100 pos-r`,
    tabIndex: -1
  }, input.topLabel && (/*#__PURE__*/_react.default.createElement("h6", {
    className: input.topLabelClass
  }, input.topLabel)), /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    disableEmailRegister: disableEmailRegister,
    onSaveData: onSaveData ? () => onSaveData() : undefined,
    baseByData: baseByData,
    showCheckMark: showCheckMark,
    baseURL: baseURL,
    ReduxFieldClass: input.ReduxFieldClass,
    autocomplete: autocompleteData,
    multiple: enableMultiple,
    component: input.component,
    formValue: formValue,
    mapOptions: {
      ...input.mapOptions
    },
    pageType: input.pageType,
    mapFunctions: {
      curCountry,
      defCountry: (0, _get.default)(formValue, 'location.countryName', ''),
      selCountry: (0, _get.default)(formValue, 'location.countryCode', '')
    },
    lang: input.lang,
    hintMessage: hintMessage ? input.hintMessage : '',
    design: {
      cardLayout: input.cardLayout,
      cardSmall: input.cardSmall,
      className: input.className || '',
      classNameParent: input.classNameParent || '',
      compact: input.compact,
      country: input.country,
      fluid: input.fluid,
      formatText: input.formatText,
      iconClass: input.iconClass,
      inputClassName: input.className || '',
      isHorizontal: input.isHorizontal,
      large: input.large,
      pdClass: input.pdClass,
      section: input.section,
      showCountCharacters: input.showCountCharacters,
      showPassword: input.showPassword !== null && typeof input.showPassword !== 'undefined' ? input.showPassword : showPassword,
      showStrongPassword: input.showStrongPassword,
      stretched: input.stretched,
      svgSupport: input.svgSupport,
      svgWidth: input.svgWidth,
      wrapClass: input.wrapClass || ''
    },
    onCloseGoBack: e => onCloseGoBack(e),
    form: form,
    input: {
      invertScale: input.invertScale || false,
      acceptedFile: input.acceptedFile || [],
      addPlusOnLast: input.addPlusOnLast,
      autofocus: (0, _get.default)(input, 'autofocus', autofocus),
      blockScroll: input.blockScroll || false,
      bulletPoints: input.bulletPoints,
      country: input.country,
      deactivable: typeof input.deactivable !== 'undefined' ? input.deactivable : true,
      deleteMultiCity: index => input.deleteMultiCity(index),
      disableAutocomplete: input.disableAutocomplete || false,
      disableDelay,
      disabled: input.disabled,
      extraFeatureCustomList: input.extraFeatureCustomList,
      minDate: input.minDate,
      multiCities: input.multiCities,
      modal: input.modal,
      moreInfo: input.moreInfo,
      name: input.name,
      onRemove: val => onRemoveFile ? onRemoveFile(val) : null,
      onSelectAddress: adr => input.onSelectAddress(adr),
      options: input.options,
      placeholder: input.placeholder || '',
      placeholderOther: input.placeholderOther,
      searchType: input.searchType,
      showFullSelectDate: input.showFullSelectDate,
      showSingleValCheck: input.showSingleValCheck,
      skipPhone: input.skipPhone,
      startFrom: input.startFrom,
      tooltip: input.tooltip,
      type: input.type || '',
      unit: input.unit,
      validate: input.validation
    },
    inputFormat: {
      currency: input.currency,
      formatType: input.formatType || '',
      max: input.max,
      maxLengthNum: (0, _isNaN.default)(+input.maxLengthNum) ? null : input.maxLengthNum,
      min: input.min,
      minLengthNum: (0, _isNaN.default)(+input.minLengthNum) ? null : input.minLengthNum,
      step: +input.step
    },
    labels: {
      buttonLabel: input.buttonLabel,
      icons: input.icons,
      label: input.label,
      labelHtml: input.labelHtml,
      labelLeft: input.labelLeft,
      labelType: input.labelType,
      labelButton: input.labelButton
    },
    meta: {
      dirty: (0, _get.default)(formValue, input.name, null) !== null,
      // @ts-ignore
      invalid: (0, _get.default)(errorValue, input.name, true) !== true && (0, _get.default)(errorValue, input.name, '') !== 'Mark Required',
      message: {
        help: null,
        error: (0, _get.default)(errorValue, input.name, null)
      },
      showErrors
    },
    onSubmit: () => onSubmit()
  })), (input.type === 'number' || input.type === 'text') && showSendButton && onClick && (/*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    rounded: true,
    label: "Ok",
    className: `ml-2 ${hideOnDesk} ${input.label ? 'mt-5' : 'mt-small-3'}`,
    theme: "green",
    onClick: () => onClick(),
    disabled: onClickDisabled
  })), input.type === 'password' && showButtonGenerate && (/*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    rounded: true,
    label: "Generate",
    className: `ml-2 ${input.label ? 'mt-4' : 'mt-small-3'}`,
    theme: "primary",
    onClick: () => generatePassword()
  }))), /*#__PURE__*/_react.default.createElement("p", {
    className: "body2"
  }, input.help)))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, inputs && inputs.map((input, f) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `inp_${f.toString()}`
  }, input.customHTML && (/*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: input.customHTML
    }
  })), input.customComponent && (/*#__PURE__*/_react.default.createElement(input.customComponent, input.customComponentProps)), input.component && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, inputComponent(input, f))), input.type === 'separator' && (/*#__PURE__*/_react.default.createElement("div", {
    className: "w-perc-100"
  }, input.showLine && (/*#__PURE__*/_react.default.createElement("hr", {
    className: "brdText100 my-4"
  })), input.title && (/*#__PURE__*/_react.default.createElement("h6", {
    className: "fsize-400 fweight-600 mb-2"
  }, input.title)), input.subtitle && (/*#__PURE__*/_react.default.createElement("p", {
    className: "txtText600 fsize-300"
  }, input.subtitle)))), input.type === 'tooltipText' && (/*#__PURE__*/_react.default.createElement("div", {
    className: `w-perc-100 dis-f a-c ${input.className}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-200 txtText600 mr-1"
  }, input.title), /*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    description: input.text
  })))))), nestedInputs && nestedInputs.map((quest, i) => (!quest?.condition || quest?.condition && valideConditionInput(quest)) && (/*#__PURE__*/_react.default.createElement("div", {
    className: `accordWrap mb-5 ${quest.classWrap ? quest.classWrap : ''}`,
    key: `nstIpt_${i.toString()}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "questContent"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-row a-c pos-r w-perc-100 mb-2"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "txtText900 fweight-600 fsize-500"
  }, quest.title)), /*#__PURE__*/_react.default.createElement("div", {
    className: quest.classQuest
  }, (0, _get.default)(quest, 'inputs', []).map((input, f) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `inps_${f.toString()}`
  }, inputComponent(input, f))))))))));
};
const mapStateToProps = (state, ownProps) => ({
  changeCountry: (0, _get.default)(state, `brixelForm[${ownProps.form}].values.changeCountry`, null),
  country: (0, _get.default)(state, 'common.country', []),
  defValue: (0, _get.default)(state, `brixelForm[${ownProps.form}].initial`, {}),
  errorValue: (0, _get.default)(state, `brixelForm[${ownProps.form}].syncErrors`, {}),
  errors: (0, _get.default)(state, `brixelForm[${ownProps.form}].syncErrors`, {}),
  form: ownProps.form,
  formValue: (0, _get.default)(state, `brixelForm[${ownProps.form}].values`, {}),
  getAllFormData: (0, _get.default)(state, 'brixelForm', {}),
  regFields: (0, _get.default)(state, `brixelForm[${ownProps.form}].registeredFields`, {})
});
const mapDispatchToProps = dispatch => ({
  changeFieldValue(form, field, value) {
    dispatch((0, _ReduxForm.change)(form, field, value));
  },
  handleUpdateErrors: (0, _redux.bindActionCreators)(_FormActions.setErrors, dispatch),
  handleUpdateValues: (0, _redux.bindActionCreators)(_FormActions.setValues, dispatch)
});
var _default = exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(MultiFileldsRedux);